<template>
  <authorization permissionKey="configuration_user" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text"> Configurações de Usuários </v-col>
      </v-row>

      <ConfigUserSessionExpirationForm />

      <v-row>
        <v-col class="text-h3 gray--text"> Usuários </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="filteredEmployees"
            sort-by="name"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-text-field
                  label="Busca"
                  v-model="filter"
                  outlined
                  dense
                  hide-details
                  clearable
                  append-icon="eva-search-outline"
                />
              </v-toolbar>
            </template>

            <template v-slot:item.actions="{ item }">
              <authorization
                permissionKey="configuration_user"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-tooltip v-if="item.user.lockedAt" top>
                  <template
                    v-if="authorization && item.user.lockedAt"
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                      @click="unlockUser(item)"
                    >
                      eva-unlock-outline
                    </v-icon>
                  </template>
                  Desbloquear usuário
                </v-tooltip>

                <v-tooltip v-else top>
                  <template
                    v-if="authorization && !item.user.lockedAt"
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                      @click="inactiveUser(item)"
                    >
                      ri-user-unfollow-line
                    </v-icon>
                  </template>

                  Inativar Usuário
                </v-tooltip>
              </authorization>

              <authorization
                permissionKey="configuration_user"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-tooltip top>
                  <template
                    v-if="authorization"
                    v-slot:activator="{ on, attrs }"
                  >
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="mr-2"
                      @click="requestPasswordChange(item)"
                    >
                      ri-mail-send-line
                    </v-icon>
                  </template>

                  Resetar senha
                </v-tooltip>
              </authorization>

              <authorization
                permissionKey="configuration_user"
                can="save"
                v-slot:default="{ authorization }"
              >
                <UserPermissions v-if="authorization" :userId="item.user.id" />
              </authorization>
            </template>

            <template v-slot:no-data>
              <v-alert color="orange" outlined text type="info">
                Não há usuários cadastradas
              </v-alert>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
import UserPermissions from "@/components/config/user/permission.vue";
import ConfigUserSessionExpirationForm from "@/components/config/user/session_expiration_time_form/index.vue";

export default {
  name: "UserConfig",
  components: {
    UserPermissions,
    ConfigUserSessionExpirationForm,
  },
  apollo: {
    employees: {
      query: require("@/graphql/employees/employees.gql"),
      pollInterval: 20000,
    },
  },
  data() {
    return {
      filter: "",
      headers: [
        { text: "Nome", value: "name" },
        { text: "Email", value: "user.email" },
        { text: "Ações", value: "actions", sortable: false, align: "end" },
      ],
    };
  },
  computed: {
    filteredEmployees() {
      let employees = this.lodash.filter(this.employees, function(e) {
        return e.user != null;
      });

      if (this.filter) {
        employees = this.lodash.filter(
          employees,
          function(e) {
            return e.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .includes(
                this.filter
                  .toLowerCase()
                  .normalize("NFD")
                  .replace(/[\u0300-\u036f]/g, "")
              );
          }.bind(this)
        );
      }

      return employees;
    },
  },
  methods: {
    requestPasswordChange(item) {
      this.apolloMutate({
        mutation: require("@/graphql/user/request_password_change.gql"),
        variables: {
          userId: item.user.id,
        },
      }).then(() => {
        this.$store.dispatch("createNotification", {
          message: "Requisição para alterar senha enviada.",
          type: "success",
        });
      });
    },
    unlockUser(item) {
      this.apolloMutate({
        mutation: require("@/graphql/user/unlock_user.gql"),
        variables: {
          userId: item.user.id,
        },
      }).then(() => {
        this.$store.dispatch("createNotification", {
          message: "Usuário foi desbloqueado.",
          type: "success",
        });
        this.refreshList();
      });
    },
    inactiveUser(item) {
      this.apolloMutate({
        mutation: require("@/graphql/user/inactive_user.gql"),
        variables: {
          userId: item.user.id,
        },
      }).then(() => {
        this.$store.dispatch("createNotification", {
          message: "Usuário foi inativado.",
          type: "success",
        });
        this.refreshList();
      });
    },
    refreshList() {
      this.$apollo.queries.employees.refetch();
    },
  },
};
</script>

<style lang="scss" scoped></style>
